"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Spinner = exports.SPINNER_TYPES = exports.SPINNER_SIZES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _focusManager = require("../utils/focusManager");
var _useAnnouncedMessage = require("../utils/_useAnnouncedMessage");
var _useUniqueId = require("../utils/useUniqueId");
var _Spinner = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var MASK_COLORS = ['gray', 'white'];
var CSS_BLOCK = 'sapcnqr-spinner';
var WHEEL_CSS_ELEMENT = "".concat(CSS_BLOCK, "__wheel");
var SPINNER_SIZES = exports.SPINNER_SIZES = ['lg', 'md', 'sm'];
var SPINNER_TYPES = exports.SPINNER_TYPES = ['block', 'fullScreen', 'fullPage', 'inline'];
/**
 * The **Spinner** component provides feedback to a user during the loading of
 * another component or page.
 *
 * In order for this component to be used with the included mask, it must be
 * placed inside an HTML element that is relatively positioned. The
 * `.cnqr-position-relative` CSS class can be used to set relative positioning
 * on any element. For example, the **Spinner** might be inside an application’s
 * parent HTML container or inside a section on the page.
 *
 * > When using Full Page and Full Screen **Spinner** components, the top level element
 * that the spinner is overlaying must contain the attribute `inert="true"` in
 * order for content to be invisible to the accessibility tree. When the **Spinner**
 * is no longer being used to overlay any elements, `inert="false"` should
 * be set to the element which previously contained the attribute so that any
 * elements that were invisible to the accessibility tree will now be visible.
 * By using this attribute, keyboard navigation and speech output will be disabled
 * to underlying elements while **Spinner** is active and will avoid confusion to sight
 * impaired users and keyboard navigation users that inaccessible/invisible elements
 * are present on the page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert)
 * for more information as to how to use the `inert` attribute.
 *
 * > Note: Using the `inert` property on a Typescript React app has some issues. See examples on how
 * to pass `inert` so that the property makes it to the DOM. See this inert
 * [issue](https://github.com/WICG/inert/issues/58#issuecomment-618016847).
 */
var Spinner = exports.Spinner = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context3;
  var id = props.id,
    messageClassName = props.messageClassName,
    messageContainerClassName = props.messageContainerClassName,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    visible = props.visible,
    wheelClassName = props.wheelClassName,
    boxClassName = props.boxClassName,
    className = props.className,
    content = props.content,
    contentClassName = props.contentClassName,
    hideMessage = props.hideMessage,
    inverted = props.inverted,
    _props$maskColor = props.maskColor,
    maskColor = _props$maskColor === void 0 ? 'gray' : _props$maskColor,
    message = props.message,
    type = props.type,
    statusProps = props.statusProps,
    otherProps = __rest(props, ["id", "messageClassName", "messageContainerClassName", "size", "visible", "wheelClassName", "boxClassName", "className", "content", "contentClassName", "hideMessage", "inverted", "maskColor", "message", "type", "statusProps"]);
  var classnames = _bind.default.bind(_Spinner.default);
  var uniqueId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    uniqueId = id;
  }
  var isFullPage = type === 'fullPage';
  var isFullScreen = type === 'fullScreen';
  var isFullView = isFullPage || isFullScreen;
  var isInline = type === 'inline';
  var isBlock = type === 'block';
  var _focusManagerRef = (0, _react.useRef)(null);
  var spinnerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsMounted(true);
  }, []);
  /**
   * Note: JAWS requires an element with `role="status"` to be initially rendered on the page,
   * and then dynamically update its content in order for it to be announced.
   */
  var announcedMessage = (0, _useAnnouncedMessage.useAnnouncedMessage)({
    announce: isFullView,
    message: message,
    disableReset: true
  }, [visible, message, isFullView]);
  var _handleFocusManager = function _handleFocusManager(node) {
    if (isFullScreen && visible && node) {
      _focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: node
      });
    }
  };
  var _getSpinnerSize = function _getSpinnerSize() {
    var _context2;
    if (isFullView) {
      return "".concat(WHEEL_CSS_ELEMENT, "--fullPage");
    }
    if (isInline) {
      var _context;
      return (0, _concat.default)(_context = "".concat(WHEEL_CSS_ELEMENT, "--inline-")).call(_context, size);
    }
    return (0, _concat.default)(_context2 = "".concat(WHEEL_CSS_ELEMENT, "--")).call(_context2, size);
  };
  var _renderSpinner = function _renderSpinner() {
    var classNames = classnames(wheelClassName, _getSpinnerSize(), WHEEL_CSS_ELEMENT);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames
    }, /*#__PURE__*/_react.default.createElement("svg", {
      "aria-hidden": true,
      className: classnames("".concat(CSS_BLOCK, "__shape")),
      viewBox: "25 25 50 50"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      className: classnames("".concat(CSS_BLOCK, "__shape--background")),
      cx: "50",
      cy: "50",
      fill: "none",
      r: "20",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      className: classnames("".concat(CSS_BLOCK, "__shape--indicator")),
      cx: "50",
      cy: "50",
      fill: "none",
      r: "20",
      strokeMiterlimit: "10"
    })));
  };
  var _renderMessaging = function _renderMessaging(messaging) {
    var textSize = '';
    if (isInline) {
      if (size === 'lg') {
        textSize = "".concat(CSS_BLOCK, "__message-inline--large");
      }
    } else if (isFullView) {
      textSize = "".concat(CSS_BLOCK, "__message--large");
    } else if (size === 'lg') {
      textSize = "".concat(CSS_BLOCK, "__message--small");
    }
    var messageContainerClassNames = classnames("".concat(CSS_BLOCK, "__message-box"), messageContainerClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-box--screen-reader-only"), hideMessage));
    var paragraphClassNames = classnames("".concat(CSS_BLOCK, "__message"), textSize, messageClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-inline"), isInline));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: messageContainerClassNames
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: paragraphClassNames,
      id: "".concat(uniqueId, "-message")
    }, messaging));
  };
  if (!visible) {
    return null;
  }
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__mask"), !isInline && !isBlock), (0, _concat.default)(_context3 = "".concat(CSS_BLOCK, "__mask--")).call(_context3, maskColor), !inverted && !isBlock && !isInline), "".concat(CSS_BLOCK, "__mask--secondary"), inverted), "".concat(CSS_BLOCK, "__mask--full-page"), isFullPage), "".concat(CSS_BLOCK, "__mask--full-screen"), isFullScreen), "".concat(CSS_BLOCK, "--inverted"), inverted), "".concat(CSS_BLOCK, "--inline"), isInline), "".concat(CSS_BLOCK, "--block"), isBlock));
  var spinnerBoxClassNames = classnames("".concat(CSS_BLOCK, "__box"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__box--inline"), isInline), "".concat(CSS_BLOCK, "__box--centered"), !isInline && !isBlock), boxClassName);
  var spinner = /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([spinnerRef, _handleFocusManager, ref])
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: spinnerBoxClassNames
  }, _renderSpinner(), /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, statusProps, {
    id: uniqueId,
    role: "status",
    "aria-describedby": isInline ? undefined : "".concat(uniqueId, "-message"),
    "aria-label": isInline ? message : undefined,
    "aria-live": isFullView ? 'assertive' : 'polite',
    className: classnames("".concat(CSS_BLOCK, "__status"), statusProps === null || statusProps === void 0 ? void 0 : statusProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-box--screen-reader-only"), !announcedMessage))
  }), announcedMessage && _renderMessaging(announcedMessage)), !announcedMessage && _renderMessaging(message), isFullScreen && content ? ( /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__content"), contentClassName)
  }, content)) : null));
  return isFullScreen && isMounted ? /*#__PURE__*/_reactDom.default.createPortal(spinner, document.body, 'spinner-portal') : spinner;
});
Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  /** The message that will be displayed/read to the user when the spinner is invoked. */
  message: _propTypes.default.string.isRequired,
  /** Custom classes to be added to the Spinner box’s wrapping `<div>`. */
  boxClassName: _propTypes.default.string,
  /** Custom classes to be added to the wrapping `<div>.` */
  className: _propTypes.default.string,
  /** Content to render under the spinner. */
  content: _propTypes.default.node,
  /** Custom classes to be added to the Spinner content’s wrapping `<div>`. */
  contentClassName: _propTypes.default.string,
  /** Hides the message text from view, but does not remove accessibility attributes.
   * **NOTE:** The `message` property is still required even if it will be hidden from
   * view to meet accessibility requirements. */
  hideMessage: _propTypes.default.bool,
  /** The DOM `id` of the spinner `<div>` element. If left blank, a random value will
   * be generated for accessibility purposes. */
  id: _propTypes.default.string,
  /** When true, the spinner will render with inverted colors and change the mask color
   * to `@brand-secondary` (for non-inline spinners). **NOTE:** To maintain consistency
   * across all of SAP Concur’s products, use the default spinner for most cases. */
  inverted: _propTypes.default.bool,
  /** The base color of the mask below the spinner. Options are `'gray'`, `'white'`. */
  maskColor: _propTypes.default.oneOf(MASK_COLORS),
  /** Custom classes to be added to the Spinner message `<p>` tag. */
  messageClassName: _propTypes.default.string,
  /** Custom classes to be added to the Spinner message’s wrapping `<div>`. */
  messageContainerClassName: _propTypes.default.string,
  /** Spinner size. Options are `'lg'`, `'md'`, `'sm'`. */
  size: _propTypes.default.oneOf(SPINNER_SIZES),
  /** Spinner type. Options are `'block'`, `'inline'`, `'fullPage'` and `'fullScreen'`. */
  type: _propTypes.default.oneOf(SPINNER_TYPES),
  /** Visibility of the spinner. Typically, a spinner is added for a component or page and
   * is not visible and gets set to visible when necessary. */
  visible: _propTypes.default.bool,
  /** Custom classes to be added to the underlying `<div>` that wraps the spinner svg. */
  wheelClassName: _propTypes.default.string
};
var _default = exports.default = Spinner;